import React, {Component} from 'react'
import Pricing from "./Pricing";
import Footer from "./Footer";
import Team from "./Team";
import Baner from "./Baner";
import Sponsorzy from "./Sponsorzy";
import Organizatorzy from "./Organizatorzy";
import {Link} from "react-router-dom";
import baner from "./assets/pw_data/baner_zielony.png";
import Patronaty from "./Patronaty";

export default class Home extends Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <>
        <Baner data={baner}/>
        <About/>
        <Pricing/>
        <Team data={this.props.data}/>
        <Patronaty/>
        <Organizatorzy data={this.props.data}/>
        <Sponsorzy data={this.props.data}/>
        <Footer/>
      </>
    );
  }
}

function About() {
  return (
    <section className="p-4 lg:p-8 bg-white text-greenPW">
      <div className="container mx-auto space-y-12">
        <div className="flex flex-col overflow-hidden rounded-md shadow-sm lg:flex-row">
          <img
            src="https://cdn.editage.com/insights/editagecom/production/Why%20attend%20scientific%20conferences_0.jpg"
            alt="" className="h-80 bg-gray-500 aspect-video"/>
          <div className="flex flex-col justify-center flex-1 p-6 bg-bezowyPW">
            <span className="text-xs uppercase text-greenPW"> #kongres #PolitechnikaWarszawska #MłodziNaukowcy #networking</span>
            <h3 className="text-3xl font-bold">Kongres Młodych Naukowców</h3>
            <p className="my-6 text-greenPW">Całokształt wydarzenia ma na celu promocję środowiska naukowego
              Politechniki Warszawskiej u potencjalnych pracodawców oraz umocnienie pozycji Uczelni i jej współpracy
              z podmiotami zewnętrznymi. Podczas wydarzenia, Młodzi Naukowcy z Politechniki Warszawskiej będą mieli
              możliwość uczestnictwa w Kongresie, gdzie będzie możliwa dyskusja nad aktualnymi problemami rozwoju
              teorii i praktyki w ramach wskazanych obszarów tematycznych.</p>
            <div
              className="flex flex-col space-y-4 sm:items-center sm:justify-center sm:flex-row sm:space-y-0 sm:space-x-4 lg:justify-start">
              <Link
                to="/kongres">
                <a rel="noopener noreferrer" href="#"
                   className="px-8 py-3 text-lg font-semibold rounded bg-greenPW text-gray-100 hover:text-orangePW">Kongres</a></Link>
            </div>
          </div>
        </div>
        <div className="flex flex-col overflow-hidden rounded-md shadow-sm lg:flex-row-reverse">
          <img src="https://geoforum.pl/upload/images/32.jpg" alt="" className="h-80 bg-gray-500 aspect-video"/>
          <div className="flex flex-col justify-center flex-1 p-6 bg-bezowyPW">
            <span className="text-xs uppercase text-greenPW">#bal #PolitechnikaWarszawska #integracja #rozrywka </span>
            <h3 className="text-3xl font-bold">Bal Młodych Naukowców</h3>
            <p className="my-6 text-greenPW">Wieńczący całość wydarzenia Bal Młodych Naukowców ma na celu ponowną
              integrację środowiska, w nieco luźniejszej atmosferze niż podczas zajęć akademickich i z porzuceniem
              barier między środowiskami stawianymi zarówno przez relacje mistrz-uczeń, ale często też
              przez reprezentację różnych grup interesów wewnątrz Uczelni </p>
            <div
              className="flex flex-col space-y-4 sm:items-center sm:justify-center sm:flex-row sm:space-y-0 sm:space-x-4 lg:justify-start">
              <Link
                to="/balNaukowca">
                <a rel="noopener noreferrer" href="#"
                   className="px-8 py-3 text-lg font-semibold rounded bg-greenPW text-gray-100 hover:text-orangePW">BMN
                  PW</a></Link>
            </div>
          </div>
        </div>
        <div className="flex flex-col overflow-hidden rounded-md shadow-sm lg:flex-row">
          <img src="https://www.nature.com/nature-index/article/image/5e3a0294081ed519042c65f5" alt=""
               className="h-80 bg-gray-500 aspect-video"/>
          <div className="flex flex-col justify-center flex-1 p-6 bg-bezowyPW">
            <span
              className="text-xs uppercase text-greenPW">#SesjaPosterowa #PlakatNaukowy #Konkurs #MłodaNauka  </span>
            <h3 className="text-3xl font-bold">Konkurs i Wystawa Posterów</h3>
            <p className="my-6 text-greenPW">Trzecią inicjatywą realizowaną w ramach Gali Młodych Naukowców
              jest Konkurs na najlepszy poster naukowy oraz Wystawa Posterów w Gmachu Głównym PW.
              Inicjatywa ta ma za zadanie promocję Nauki na Politechnice Warszawskiej wśród Młodych
              Naukowców oraz połączenie środowiska akademickiego z różnych dziedzin nauk na naszej Alma Mater.</p>
            <div
              className="flex flex-col space-y-4 sm:items-center sm:justify-center sm:flex-row sm:space-y-0 sm:space-x-4 lg:justify-start">
              <Link to="/plakaty">
                <a rel="noopener noreferrer" href="#"
                   className="px-8 py-3 text-lg font-semibold rounded bg-greenPW text-gray-100 hover:text-orangePW">Sesja
                  Posterowa</a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
